import React, { Suspense } from 'react';
import { Link, RouteComponentProps } from '@reach/router';
import { getWebAppInfo } from '@/utils';
import env from '@/env';
import HelmetHead from '@/components/HelmetHead/HelmetHead';
import LoadingFullPage from '@/components/LoadingFullPage/LoadingFullPage';
import './AuthLayout.scss';

interface AuthLayoutProps extends RouteComponentProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const webApp = getWebAppInfo(env.siteId);

  return (
    <div className="AuthLayout">
      <HelmetHead title={webApp.siteName} description={webApp.siteName} />
      <div className="AuthLayout-container container">
        <Link to="/">
          <div className={`AuthLayout-logo ${webApp.appName}`}>
            <img src={webApp.mainLogo} alt={webApp.siteName} />
          </div>
        </Link>
        <div className="AuthLayout-main">
          <Suspense fallback={<LoadingFullPage />}>{children}</Suspense>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
